module.exports = __webpack_public_path__ + "static/media/AccessDeniedHeader.6373787e.png";